import { useTranslation } from 'next-i18next'
import { type FC } from 'react'
import { useTheme } from 'styled-components'

import { TRANSLATION_KEYS } from '@/constants/localization'
import { ListingReportForm } from '@/features/listing/components/report/ListingReportForm'
import { MODAL_REGISTRY } from '@/features/modal/constants/modalRegistry'
import { useModal } from '@/features/modal/hooks/useModal'
import { Flex } from '@/ui/atoms/flex/Flex'
import { HeadlineText } from '@/ui/atoms/headline-text/HeadlineText'
import { Modal } from '@/ui/molecules/modal/Modal'

type ListingReportModalProps = {
  /**
   * The ID of the listing to report.
   */
  listingId: string
}

/**
 * Modal to report a listing. It contains a form to report the listing.
 */
export const ListingReportModal: FC<ListingReportModalProps> = ({ listingId }) => {
  const { isOpen, handleCloseModal } = useModal(MODAL_REGISTRY.LISTING_REPORT)
  const { t } = useTranslation([TRANSLATION_KEYS.LISTING])
  const { spacing } = useTheme()

  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      id={MODAL_REGISTRY.LISTING_REPORT}
      label={t('listing:report.modal.title')}
      hasCloseButton
      onCancel={handleCloseModal}
      padding={spacing.xLarge}
    >
      <Flex flexDirection="column" gap={spacing.large}>
        <HeadlineText as="h2" size="large" textAlign="center">
          {t('listing:report.modal.title')}
        </HeadlineText>

        <ListingReportForm listingId={listingId} onClose={handleCloseModal} />
      </Flex>
    </Modal>
  )
}
